module.exports = __webpack_public_path__ + "static/ania-avatar-c212f8053f49df220babc9966cf19eee.webp";